export default __webpack_public_path__ + "static/media/audio.9500b712.svg";